import React from "react";

/*
 * In-page loading state for Signals. BrandedBootLoader is the app's full-screen boot splash
 * (fixed over the header, nav and rail), so using it on a route change made every visit look
 * like a full page reload. Same fix as agents/AgentPageSkeleton.
 */
const SignalsSkeleton = ({ label = "Loading signals" }) => (
  <div className="sg-skel" aria-busy="true" aria-label={label}>
    <div className="sg-skel__stats">
      <span className="linear-background" />
      <span className="linear-background" />
      <span className="linear-background" />
    </div>
    <div className="sg-skel__rows">
      <span className="linear-background" />
      <span className="linear-background" />
      <span className="linear-background" />
      <span className="linear-background" />
    </div>
  </div>
);

export default SignalsSkeleton;
